export default __webpack_public_path__ + "static/luzean-cloud-6551b72a8c468e3f99d41f7dc254533a.webp";